import { ISnapshotData } from "../dataProcessors";
import { ChroniclerWrappedData, GameModel, PlayerModel, SimModel, TeamModel } from "../models/models";

// S1
const Season_1_Start_Date = "2023-01-09T11:19:00.30342Z"
const Season_1_Pre_Elections_Date = "2023-01-15T06:06:16.184Z"; // After the postseason, before elections
const Season_1_Post_Elections_Date = "2023-01-17T06:06:16.184Z"; // After the election
const Season_1_Final_Date = "2023-01-20T21:07:30.285605Z" // Last date before the sim ticked over
type Snapshots_Season_1 = (typeof Season_1_Start_Date) | (typeof Season_1_Pre_Elections_Date) | (typeof Season_1_Post_Elections_Date) | (typeof Season_1_Final_Date)

// S2
const Season_2_Start_Date = "2023-01-22T17:10:26.202Z" // Sunday before S2 started
const Season_2_Pre_Election = "2023-01-29T17:00:22.044Z" // After postseason, an hour before elections
type Snapshots_Season_2 = (typeof Season_2_Start_Date) | (typeof Season_2_Pre_Election)


type KnownSnapshotDate = Snapshots_Season_1 | Snapshots_Season_2

export type Snapshot = {
    name: string,
    date: KnownSnapshotDate
}

export const SnapshotsToLoad: Snapshot[] = [
    { name: "Season 1 Start", date: Season_1_Start_Date },
    { name: "Season 1 Pre-Election", date: Season_1_Pre_Elections_Date },
    { name: "Season 2 Start", date: Season_2_Start_Date },
    { name: "Season 2 Pre-Election", date: Season_2_Pre_Election },
]

export const EndOfSeasonSnapshots: Snapshot[] = [
    { name: "Season 1 End", date: Season_1_Pre_Elections_Date },
    { name: "Season 2 End", date: Season_2_Pre_Election },
]


export interface ISnapshotResults {
    snapshot: Snapshot,
    simResult: ChroniclerWrappedData<SimModel>,
    teamsResult: ChroniclerWrappedData<TeamModel>,
    playersResult: ChroniclerWrappedData<PlayerModel>,
    gamesResult?: ChroniclerWrappedData<GameModel>
}

export function getSnapshotData(snapshot?: Snapshot, snapshots?: ISnapshotData[]): ISnapshotData | false {
    if (!snapshot || !snapshots) {
        return false;
    }
    const matchingDatas = snapshots.filter(data => data.snapshot.date === snapshot.date);
    if (matchingDatas.length !== 1) {
        console.log(`Tried to find snapshot [${snapshot.name}] but got ${matchingDatas.length} matches`)
        return false;
    }
    return matchingDatas[0];
}
